<!--
  FAQ
-->
<div class="faq" style="margin-top: 60px; text-align: center;" *ngIf="hasFaq">

  <a href="{{companyParamsService.getFaqLink()}}" [ngStyle]="{ 'color': '#'+this.companyParamsService.getMainColor() }"
    target="_blank" rel="noopener noreferrer">Frequently Asked Questions</a>
</div>

<!--
  slogan price
-->

<div class="haslogo" *ngIf="hasSloganPrice">

  <div class="mb-5" style="margin-bottom: 0px !important; margin-top: 20px; text-align: center;"
    *ngIf="validateImgPath(companyParamsService.getSloganImage())">
    <img class="resize-image" src="{{companyParamsService.getSloganImage()}}" alt="price" style="max-width: 250px;">
  </div>
  <p class="text-muted small text-center" style="font-size: 11.2px;"> {{companyParamsService.getSloganPrice()}}
    <br>
    <b *ngIf="companyParamsService.getApplyTermsCondition()"> *Terms and Conditions apply</b>
  </p>
</div>

<!--
payments logo

-->
<div *ngIf="hasPaymentsIcons && paymentsIcons.length>0 ">
  <p>We accept:</p>
  <img *ngFor="let icon of paymentsIcons" class="mr-2 mt-2 img-payments-logos" src="assets/images/payments/{{icon.img}}"
    alt="{{icon.img}}" height="{{icon.heightValue}}">

</div>